<script>
import itemTemplate from './item-template.vue'
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import { ErrorWrapper } from '@utils/error-handler'
import { BOverlay } from 'bootstrap-vue'
import {
  authComputed,
  userListMethod,
  siteListMethod,
  batchListMethod,
  courseListMethod,
} from '@state/helpers'
import { Quill } from 'vue-quill-editor'
var Link = Quill.import('formats/link')
var builtInFunc = Link.sanitize
Link.sanitize = function customSanitizeLinkInput(linkValueInput) {
  var val = linkValueInput

  // do nothing, since this implies user's already using a custom protocol
  if (/^\w+:/.test(val));
  else if (!/^https?:/.test(val)) val = 'http://' + val

  return builtInFunc.call(this, val) // retain the built-in logic
}

export default {
  page: {
    title: 'Add Course Content',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    'b-overlay': BOverlay,
  },
  data() {
    return {
      title: '',
      description: '',
      content: [
        {
          title: '',
          videoId: '',
          pdf_link: '',
          note_link: '',
          exercise_link: '',
        },
      ],
      demoVideo: '',
      demoDoc: '',
      type: '',
      status: true,
      price: 0,
      liveStatus: '',
      userError: null,
      isUserError: false,
      isLoading: false,
      show: false,
      platformId: '',
      platform: '',
      collegeId: '',
      collegeName: '',
      teacherList: [],
      teacherDataList: [],
      batchList: [],
      titleError: false,
      statusList: [
        { text: 'True', value: true },
        { text: 'False', value: false },
      ],
      typeList: [
        { text: 'Self Paced', value: 'SELF_PACED' },
        { text: 'Instructor Led', value: 'INSTRUCTOR_LED' },
      ],
      trainerId: '',
      trainerList: [],
      courseBatchId: '',
      courseBatchList: [],
      demoVideoSizeError: false,
      uploadedDoc: false,
      typeError: false,
      videoList: [],
      search: '',
      itemTemplate,
      item: '',
      sortOrder: '',
    }
  },
  computed: {
    ...authComputed,
    filteredItems() {
      return this.autocompleteItems.filter((i) => {
        return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1
      })
    },
  },
  mounted() {
    this.getCourseBatch()
    this.getTrainerList()
  },
  methods: {
    ...userListMethod,
    ...siteListMethod,
    ...batchListMethod,
    ...courseListMethod,
    getCourseBatch() {
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 3000,
        sort: 'sort_order',
        order: '-1',
        course_id: this.$route.params.courseId,
      }
      this.fetchCourseBatchList({ filter })
        .then((courseBatchList) => {
          this.isLoading = false
          var listitems = []
          courseBatchList.forEach((element) => {
            var ele = {}
            ele.text = element.type
            ele.value = element._id
            ele.platform_id = element.platform_id
            ele.platform = element.platform
            listitems.push(ele)
          })
          this.courseBatchId = listitems[0].value
          this.platformId = listitems[0].platform_id
          this.platform = listitems[0].platform
        })
        .catch((error) => {
          this.isLoading = false
          this.tryingToLogIn = false
          var getError = new ErrorWrapper(error)
          this.authError = getError.message
          this.isAuthError = true
          window.scrollTo(0, 0)
        })
    },

    getTrainerList() {
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 3000,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchTrainerList({ filter })
        .then((trainerList) => {
          this.isLoading = false

          var listitems = []
          trainerList.docs.forEach((element) => {
            var ele = {}
            ele.text = element.type
            ele.value = element._id
            listitems.push(ele)
          })
          this.trainerList = listitems
        })
        .catch((error) => {
          this.isLoading = false
          this.tryingToLogIn = false
          var getError = new ErrorWrapper(error)
          this.authError = getError.message
          this.isAuthError = true
        })
    },

    addContentData() {
      if (this.content) {
        let i = 0
        for (i = 0; i < this.content.length; i++) {
          if (
            this.content[i].title === '' &&
            (this.content[i].videoId !== '' ||
              this.content[i].pdf_link !== '' ||
              this.content[i].note_link !== '' ||
              this.content[i].exercise_link !== '')
          ) {
            this.titleError = true
          } else {
            this.titleError = false
          }
        }
      }

      if (!this.titleError && !this.typeError) {
        this.isLoading = true
        const Data = {
          course_id: this.$route.params.courseId,
          batch_id: this.courseBatchId,
          title: this.title,
          status: this.status,
          demo_video: this.demoVideo,
          demo_doc: this.demoDoc,
          content: this.content,
          platform: this.platform,
          platform_id: this.platformId,
          sort_order: this.sortOrder,
        }
        this.addCourseContent({ Data })
          .then((resp) => {
            this.isLoading = false
            this.$router.push({ name: 'course.list' })
          })
          .catch((error) => {
            this.isLoading = false
            var getError = new ErrorWrapper(error)
            this.userError = getError.message
            this.isUserError = true
          })
      }
    },

    uploadImage: function (id) {
      this.typeError = false
      var file = document.getElementById(id).files[0]
      if (Math.round(file.size / 1024) >= 2094) {
        this.demoVideoSizeError = true
        return
      } else {
        this.demoVideoSizeError = false
      }
      if (file.type === 'application/pdf') {
        var reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = (evt) => {
          let img = new Image()
          img.onload = () => {
            localStorage.setItem('width', img.width)
            localStorage.setItem('height', img.height)
          }
          img.src = evt.target.result
          const Data = {
            image: reader.result,
            prefix: 'video',
          }
          this.fileUpload({ Data }).then((res) => {
            this.demoDoc = res.key
          })
        }
      } else {
        this.typeError = true
      }
    },

    uploadImageContent: function (id, index) {
      this.typeError = false
      var file = document.getElementById(id + index).files[0]
      if (Math.round(file.size / 1024) >= 2094) {
        alert('File size should be less than 2 mb')
        return
      }

      // if (this.content.length !== index) {
      //   this.content.push({
      //     title: '',
      //     videoId: '',
      //     pdf_link: '',
      //     note_link: '',
      //     exercise_link: '',
      //   })
      // }
      if (file.type === 'application/pdf') {
        this.uploadedDoc = true
        var reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = (evt) => {
          let img = new Image()
          img.onload = () => {
            localStorage.setItem('width', img.width)
            localStorage.setItem('height', img.height)
          }
          img.src = evt.target.result
          const Data = {
            image: reader.result,
            prefix:
              id === 'pdf_link'
                ? 'pdf'
                : id === 'note_link'
                ? 'note'
                : 'exercise',
            name: file.name,
          }
          this.fileUpload({ Data }).then((res) => {
            this.content[index][id] = res.key
            this.uploadedDoc = false
          })
        }
      } else {
        this.typeError = true
      }
    },

    restrictChars(event) {
      if (event.charCode === 32 && !this.title.length) {
        event.preventDefault()
      } else {
        return true
      }
    },

    restrictChars1(event) {
      if (event.charCode === 32 && !this.description.length) {
        event.preventDefault()
      } else {
        return true
      }
    },

    restrictNegativeNumber(event) {
      if (event.keyCode >= 48 && event.keyCode <= 57) {
        return true
      } else {
        event.preventDefault()
      }
    },

    selectTeacher() {
      this.teacherList = []
      this.teacherId = null
      var i = 0
      this.teacherList.push({
        value: null,
        text: 'Select Teacher',
        disabled: true,
      })
      for (i = 0; i < this.teacherDataList.length; i++) {
        if (this.teacherDataList[i].batch === this.batchId) {
          this.teacherList.push({
            value: this.teacherDataList[i].value,
            text: this.teacherDataList[i].text,
          })
        }
      }
    },
    incrementContent() {
      this.content.push({
        title: '',
        videoId: '',
        pdf_link: '',
        note_link: '',
        exercise_link: '',
      })
    },
    removeContent() {
      this.content.pop()
    },
    onTextChange(event, index) {
      this.content[index][event.target.id] = event.target.value
      this.search = event.target.value
    },

    getVideoIds(event) {
      this.videoList = []
      this.search = event
      const Data = { id: this.search }
      this.getVideos({ Data }).then((res) => {
        var listitems = []
        res.data.forEach((element) => {
          let ele = {}
          ele.text = element.name
          ele.value = element.uri.substring(8)
          listitems.push(ele)
        })
        this.videoList = listitems
      })
    },
    setLabel(item) {
      this.item = item
      return item.value
    },
    setLabelDemo(item) {
      return item.value
    },
    itemSelected(item, index) {
      this.content[index].videoId = this.item.value
    },
    itemSelectedDemo(item) {
      this.demoVideo = item.value
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-overlay :show="show" :opacity="0.6" rounded="sm">
          <b-card>
            * Mandatory Fields<br /><br />
            <b-alert
              v-model="isUserError"
              variant="danger"
              v-html="userError"
            ></b-alert>
            <b-form
              data-parsley-validate
              novalidate
              @submit.prevent="addContentData"
            >
              <b-form-group label="Content Title*" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="title"
                  type="text"
                  placeholder="Enter Title"
                  @keypress="restrictChars($event)"
                ></b-form-input>
              </b-form-group>
              <div style="padding: 10px; border: 1px solid black">
                <div v-for="(row, index) in content" :key="index">
                  <b-form-group label="Sub Content Title*" label-for="input-1">
                    <b-form-input
                      id="title"
                      type="text"
                      placeholder="Enter Title"
                      @keyup="onTextChange($event, index)"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    label="Sub Content Video Id"
                    label-for="input-1"
                  >
                    <vue-suggestion
                      id="videoId"
                      placeholder="Enter Video Title"
                      input-classes="form-control"
                      :items="videoList"
                      :item-template="itemTemplate"
                      :set-label="setLabel"
                      @changed="getVideoIds($event)"
                      @selected="itemSelected(item, index)"
                    >
                    </vue-suggestion>
                  </b-form-group>
                  <b-form-group
                    label="Sub Content Pdf Link"
                    label-for="input-1"
                  >
                    <b-form-file
                      :id="'pdf_link' + index"
                      placeholder="Choose a file or drop it here..."
                      drop-placeholder="Drop file here..."
                      @change="uploadImageContent('pdf_link', index)"
                    ></b-form-file>
                  </b-form-group>
                  <b-form-group
                    label="Sub Content Note Link"
                    label-for="input-1"
                  >
                    <b-form-file
                      :id="'note_link' + index"
                      placeholder="Choose a file or drop it here..."
                      drop-placeholder="Drop file here..."
                      @change="uploadImageContent('note_link', index)"
                    ></b-form-file>
                  </b-form-group>
                  <b-form-group
                    label="Sub Content Exercise Link"
                    label-for="input-1"
                  >
                    <b-form-file
                      :id="'exercise_link' + index"
                      placeholder="Choose a file or drop it here..."
                      drop-placeholder="Drop file here..."
                      @change="uploadImageContent('exercise_link', index)"
                    ></b-form-file>
                  </b-form-group>
                </div>
                <div
                  id="show-modal"
                  class="btn btn-info"
                  @click="incrementContent"
                  ><i class="ti-plus"></i>Add More Content</div
                >&nbsp;&nbsp;
                <div
                  v-if="content.length > 1"
                  id="show-modal"
                  class="btn btn-info"
                  @click="removeContent"
                  ><i class="ti-minus"></i>&nbsp;Remove Content</div
                >
              </div>
              <!--<b-form-group label="Demo Video" label-for="input-1">
                <vue-suggestion
                  placeholder="Enter Video Title"
                  input-classes="form-control"
                  :items="videoList"
                  :item-template="itemTemplate"
                  :set-label="setLabelDemo"
                  @changed="getVideoIds($event)"
                  @selected="itemSelectedDemo"
                >
                </vue-suggestion>
              </b-form-group>
              <b-form-group label="Demo Document" label-for="input-1">
                <b-form-file
                  id="demoDoc"
                  placeholder="Choose a file or drop it here..."
                  drop-placeholder="Drop file here..."
                  @change="uploadImage('demoDoc')"
                ></b-form-file>
                <p v-if="demoVideoSizeError" class="showError"
                  >File size should be less than 2 MB</p
                >
              </b-form-group> -->
              <b-form-group label="Sort Order" label-for="input-1">
                <b-form-input
                  v-model="sortOrder"
                  type="number"
                  placeholder="Add sort order"
                  @keypress="restrictNegativeNumber($event)"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Select Status*" label-for="input-1">
                <b-form-select
                  v-model="status"
                  :options="statusList"
                ></b-form-select>
              </b-form-group>
              <p v-if="titleError" style="color: red"
                >Sub Content Title is required</p
              >
              <p v-if="typeError" style="color: red"
                >Please upload only pdf files</p
              >
              <b-form-group id="button-group" class="mt-4">
                <b-button
                  v-if="!isLoading && !uploadedDoc"
                  type="submit"
                  variant="primary"
                  style="color: white"
                  >Save</b-button
                >
                <b-button
                  v-else
                  type="submit"
                  variant="primary"
                  class="btn-block"
                  disabled
                >
                  <b-spinner small></b-spinner>Loading...
                </b-button>
              </b-form-group>
              <a class="cancel-anchor" href="/course-list"
                ><b-button
                  v-if="!isLoading"
                  class="cancel"
                  type="button"
                  variant="primary"
                  >Cancel</b-button
                ></a
              >
            </b-form>
          </b-card>
        </b-overlay>
      </div>
    </div>
  </Layout>
</template>
<style>
.cancel {
  background-color: grey;
}
.cancel:hover {
  background-color: grey !important;
}
.cancel:active {
  background-color: grey !important;
}

.cancel-anchor {
  color: white !important;
}
.cancel-anchor:hover {
  color: white;
}
.vue-tags-input {
  max-width: 100% !important;
}

.ti-new-tag-input-wrapper input {
  font-family: 'Roboto', sans-serif;
  font-size: 0.9rem;
  font-weight: 400;
}
.ti-tag::before {
  display: none;
}
[class^='ti-'],
[class*=' ti-'] {
  font-size: inherit !important;
  font-weight: inherit !important;
}
.vue-suggestion .vs__list {
  position: relative;
  z-index: 10000;
  width: 100%;
  max-height: 100px;
  overflow-y: auto;
  text-align: left;
  border: none;
  border-top: none;
  border-bottom: 1px solid #023d7b;
}
.vue-suggestion .vs__list .vs__list-item {
  padding: 10px;
  cursor: pointer;
  background-color: #fff;
  border-right: 1px solid #023d7b;
  border-left: 1px solid #023d7b;
}
.vue-suggestion .vs__list .vs__list-item:last-child {
  border-bottom: none;
}
.vue-suggestion .vs__list .vs__list-item:hover {
  background-color: #eee !important;
}
.vue-suggestion .vs__list,
.vue-suggestion .vs__loading {
  position: absolute;
}
.vue-suggestion .vs__list .vs__list-item.vs__item-active {
  background-color: #f3f6fa;
}
</style>
